import { Dropdown, Menu } from "antd";
import { VFC } from "react";

export const ActionMenu: VFC<{
  isCurrentUserGameMaster: boolean;
  isMe?: boolean;
  onRemovePlayer: () => void;
}> = ({ isCurrentUserGameMaster, onRemovePlayer, isMe }) => {
  if (!isCurrentUserGameMaster) {
    return null;
  }
  return (
    <Dropdown.Button
      key={"actionMenu"}
      trigger={["click"]}
      overlay={
        <Menu
          onClick={(event) => {
            switch (event.key) {
              case "kick":
                onRemovePlayer();
                return;
            }
          }}
        >
          <Menu.Item disabled={isMe} key={"kick"}>
            Spieler entfernen
          </Menu.Item>
        </Menu>
      }
    />
  );
};
